import { ReminderMode } from '../types/API'

export const DEFAULT_REMINDERS_FREQUENCY_DAYS = 7
export const DEFAULT_REMINDERS_MODE = ReminderMode.FREQUENCY
export const REMINDERS_ENABLED_STATUS = 'ENABLED' as const
export const REMINDERS_DISABLED_STATUS = 'DISABLED' as const
export const FREQUENCY_MODE_MAX_DAYS = 45
